import React, { useEffect, useState } from 'react'
import styles from './WelcomePage.module.scss'
import WelcomeHeader from './components/WelcomeHeader/WelcomeHeader'
import { ShoppingCartIcon, ComputerIcon, PeopleIcon, MovieIcon, PlaneIcon, DiamondIcon, ScrollIcon } from 'components/CustomIcons'
import ProfilePage from '../ProfilePage/ProfilePage'
import AboutUsSection from './components/WelcomeSections/AboutUsSection/AboutUsSection'
import ContactsSection from './components/WelcomeSections/ContactsSection/ContactsSection'

import EnterToSystemSection from './components/WelcomeSections/EnterToSystemSection/EnterToSystemSection'
import WelcomeFooter from './components/WelcomeFooter/WelcomeFooter'
import OurProductsSection from './components/WelcomeSections/OurProductsSection/OurProductsSection'
import CatalogsPreview from '../../components/CatalogsPreview/CatalogsPreview'
import CategoryProductsPage from '../CategoryProductsPage/CategoryProductsPage'
import ProductPage from '../ProductPage/ProductPage'
import OurServicesSection from './components/WelcomeSections/OurServicesSection/OurServicesSection'
import { useAuth } from 'contexts/AuthContext'

// New pages
import AboutUsPage from './pages/AboutUsPage/AboutUsPage'
import ContactsPage from './pages/ContactsPage/ContactsPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage'

// Service pages
import ShopPage from '../Services/ShopPage/ShopPage'
import FoodPage from '../Services/FoodPage/FoodPage'
import ITPage from '../Services/ITPage/ITPage'
import ServersPage from '../Services/ServersPage/ServersPage'
import CommunityPage from '../Services/CommunityPage/CommunityPage'
import MoviePage from '../Services/MoviePage/MoviePage'
import AnimePage from '../Services/AnimePage/AnimePage'
import EventsPage from '../Services/EventsPage/EventsPage'
import MediaPage from '../Services/MediaPage/MediaPage'
import TourismPage from '../Services/TourismPage/TourismPage'
import DonationsPage from '../DonationsPage/DonationsPage'
import DonationHistoryPage from '../DonationHistoryPage/DonationHistoryPage'
const WelcomePage = () => {
    const [view, setView] = useState({ type: 'main', id: null }); // type: main | category | product | service | about | contacts | privacy
    const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
    const { fetchProfile } = useAuth();

    const handleMouseDown = (event) => {
    if (event.button === 2) {
      event.preventDefault();
      
    }
  };

  // попап

  // Scroll to top when view changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view.type]);

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  // Обработка Google OAuth redirect
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('access_token')) {
      console.log('🔐 Google OAuth redirect detected');
      setGoogleAuthLoading(true);
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      
      if (accessToken) {
        // Отправляем токен на бэкенд для регистрации/входа
        fetch('https://security.ncore.kg/api/account/google/callback/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ access_token: accessToken })
        })
          .then(async res => {
            const data = await res.json();
            if (!res.ok) {
              throw new Error(data.error || 'Ошибка авторизации');
            }
            return data;
          })
          .then(async data => {
            if (data.access && data.refresh && data.user) {
              console.log('✅ Google Auth Success:', data.is_new_user ? 'New user registered' : 'Existing user logged in');
              console.log('📦 User data received:', data.user);
              
              // Сохраняем токены в localStorage
              localStorage.setItem('token', data.access);
              localStorage.setItem('access_token', data.access);
              localStorage.setItem('refresh_token', data.refresh);
              localStorage.setItem('auth_user', JSON.stringify(data.user));
              
              // Очищаем hash из URL сразу
              window.history.replaceState(null, '', window.location.pathname);
              
              // Обновляем профиль через fetchProfile для синхронизации state
              try {
                const profileData = await fetchProfile(data.access);
                console.log('✅ Profile fetched and state updated:', profileData);
                
                // Принудительно обновляем state через событие
                window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: data.user }));
                
                // Форсируем обновление компонента профиля
                setTimeout(() => {
                  window.dispatchEvent(new CustomEvent('refreshProfile'));
                }, 100);
              } catch (profileErr) {
                console.warn('⚠️ Profile fetch warning (using data from auth response):', profileErr);
                // Не критично, данные уже есть в localStorage
              }
              
              // Убираем loading состояние
              setGoogleAuthLoading(false);
            } else {
              throw new Error('Некорректный ответ сервера: отсутствуют необходимые данные');
            }
          })
          .catch(err => {
            console.error('❌ Google auth error:', err);
            setGoogleAuthLoading(false);
            window.history.replaceState(null, '', window.location.pathname);
            
            // Показываем alert только для реальных ошибок
            const errorMessage = err.message || 'Неизвестная ошибка';
            if (!errorMessage.includes('fetch') && !errorMessage.includes('NetworkError')) {
              alert('Ошибка авторизации через Google:\n' + errorMessage);
            }
          });
      }
    }
  }, [fetchProfile, setView]);
  const openCategory = (id) => setView({ type: 'category', id });
  const openProduct = (id) => setView((prev) => ({ type: 'product', id, prevCategoryId: prev.type === 'category' ? prev.id : prev.prevCategoryId }));
  const openService = (serviceName, data = null) => setView({ type: 'service', id: serviceName, data });
  const handleNavigate = (page) => setView({ type: page, id: null });
  const goHome = () => setView({ type: 'main', id: null });
  const goBack = () => {
    if (view.type === 'product') {
      if (view.prevCategoryId) setView({ type: 'category', id: view.prevCategoryId });
      else setView({ type: 'main', id: null });
    } else setView({ type: 'main', id: null });
  };

  return (
    <div className={styles.wrapper}>
      {googleAuthLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          color: 'white',
          fontSize: '24px',
          fontWeight: '600',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '4px solid rgba(255, 255, 255, 0.2)',
            borderTopColor: '#fff',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite'
          }}></div>
          <div>Авторизация через Google...</div>
        </div>
      )}
      <div className={styles.wrapper_header}>
        <WelcomeHeader goBack={goBack} onOpenProfile={() => setView({ type: 'profile', id: null })} onOpenService={openService} onNavigate={handleNavigate} />
      </div>
      <div className={styles.wrapper_body}>
        {view.type === 'main' && (
          <>
            <EnterToSystemSection />
            <OurServicesSection onOpenService={openService} />
            {/* <CatalogsPreview onOpenCategory={openCategory} onOpenProduct={openProduct} /> */}
          </>
        )}

        {view.type === 'profile' && (
          <div className={styles.content}>
            <ProfilePage goBack={goBack} />
          </div>
        )}

        {view.type === 'about' && (
          <div className={styles.content}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <AboutUsPage goBack={goBack} />
          </div>
        )}

        {view.type === 'contacts' && (
          <div className={styles.content}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <ContactsPage goBack={goBack} />
          </div>
        )}

        {view.type === 'privacy' && (
          <div className={styles.content}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <PrivacyPolicyPage goBack={goBack} />
          </div>
        )}

        {view.type === 'category' && (
          <div className={styles.content}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <CategoryProductsPage embedded={true} embeddedCategoryId={view.id} onOpenProduct={(pid) => openProduct(pid)} />
          </div>
        )}

        {view.type === 'product' && (
          <div className={styles.content}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <ProductPage embedded={true} embeddedProductId={view.id} />
          </div>
        )}

        {view.type === 'service' && (
          <div className={styles.serviceView}>
            <div className={styles.controlsRow}>
              <button onClick={goBack} className={styles.backButton}>
                
                <span className={styles.backText}>Назад</span>
              </button>
            </div>
            <div className={styles.serviceContainer}>
              {/* E-commerce Services */}
              {(view.id === 'shop' || view.id === 'food') && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <ShoppingCartIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>E-commerce</span>
                  </div>
                  {view.id === 'shop' && <ShopPage embedded={true} goBack={goBack} />}
                  {view.id === 'food' && <FoodPage embedded={true} goBack={goBack} />}
                </div>
              )}

              {/* Technology Services */}
              {(view.id === 'it' || view.id === 'servers') && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <ComputerIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>Технологии</span>
                  </div>
                  {view.id === 'it' && <ITPage embedded={true} goBack={goBack} />}
                  {view.id === 'servers' && <ServersPage embedded={true} goBack={goBack} />}
                </div>
              )}

              {/* Community Services */}
              {(view.id === 'community' || view.id === 'events') && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <PeopleIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>Сообщество</span>
                  </div>
                  {view.id === 'community' && <CommunityPage embedded={true} goBack={goBack} />}
                  {view.id === 'events' && <EventsPage embedded={true} goBack={goBack} />}
                </div>
              )}

              {/* Entertainment Services */}
              {(view.id === 'movie' || view.id === 'anime' || view.id === 'media') && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <MovieIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>Развлечения</span>
                  </div>
                  {view.id === 'movie' && <MoviePage embedded={true} goBack={goBack} />}
                  {view.id === 'anime' && <AnimePage embedded={true} goBack={goBack} />}
                  {view.id === 'media' && <MediaPage embedded={true} goBack={goBack} />}
                </div>
              )}

              {/* Travel Services */}
              {view.id === 'tourism' && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <PlaneIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>Путешествия</span>
                  </div>
                  <TourismPage embedded={true} goBack={goBack} />
                </div>
              )}

              {/* Donations */}
              {view.id === 'donations' && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <DiamondIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>Донаты</span>
                  </div>
                  <DonationsPage />
                </div>
              )}

              {/* Donation History */}
              {view.id === 'donation-history' && (
                <div className={styles.serviceCategory}>
                  <div className={styles.categoryBadge}>
                    <ScrollIcon className={styles.badgeIcon} size={20} />
                    <span className={styles.badgeText}>История донатов</span>
                  </div>
                  <DonationHistoryPage />
                </div>
              )}
            </div>
          </div>
        )}

        <h5 className={styles.footerText}>
          Copyright 2025, All Rights Reserved by NCORE
        </h5>
      </div>
    </div>
  )
}

export default WelcomePage
